module.exports = __webpack_public_path__ + "img/logooficial.ca649fb6.png";